import Hero from "../../components/Hero";
import { happyOranges } from "../../themes/colours";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./styles.scss";
const MeetTheTeamPage = () => {
  const tabs = [
    {
      title: "Insights & Media - John Lewis",
      eventKey: "johnLewis",
      teamMembers: [
        {
          name: "Anna Khan",
          jobTitle: "Media Sales & Planning Lead",
          category: "",
          email: "anna.khan@johnlewis.co.uk",
        },
        {
          name: "Louise Elliott",
          jobTitle: "Senior Media Sales & Planning Manager",
          category: ", Fashion",
          email: "louise.m.elliott@johnlewis.co.uk",
        },
        {
          name: "Kathryn Staples",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Nursery and Kids",
          email: "kathryn.staples@johnlewis.co.uk",
        },
        {
          name: "Ayeisha Ashman",
          jobTitle: "Media Sales & Planning Manager",
          category: "",
          email: "ayeisha.ashman@johnlewis.co.uk",
        },
        {
          name: "Francesco Covelluzzi",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Tech",
          email: "francesco.covelluzzi@johnlewis.co.uk",
        },
        {
          name: "Frankie Ünlü",
          jobTitle: "Senior Media Sales & Planning Manager",
          category: ", Beauty",
          email: "frankie.unlu@johnlewis.co.uk",
        },
        {
          name: "Keira Hall",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Beauty",
          email: "keira.hall@johnlewis.co.uk",
        },
        {
          name: "Tully Herrmann",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Beauty",
          email: "tully.herrmann@johnlewis.co.uk",
        },
        {
          name: "Aimee Glover",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Beauty",
          email: "aimee.glover@johnlewis.co.uk",
        },
        {
          name: "Hannah D'Souza",
          jobTitle: "Media Sales & Planning Assistant",
          category: ", Beauty",
          email: "hannah.d'souza@johnlewis.co.uk",
        },
        {
          name: "Iman Gordon-Ffrench",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Home",
          email: "iman.gordon-ffrench@johnlewis.co.uk",
        },
        {
          name: "Abbie Rigg-Milner",
          jobTitle: "Media Sales & Planning Specialist",
          category: ", Home",
          email: "abbie.rigg-milner@johnlewis.co.uk",
        },
        {
          name: "Jason King",
          jobTitle: "Senior Media Sales & Planning Manager (Electricals)",
          category: ", Tech",
          email: "jason.king@johnlewis.co.uk",
        },
        {
          name: "Manoj Jadeja",
          jobTitle: "Senior Media Sales & Planning Manager (TV and Audio)",
          category: ", Tech",
          email: "manoj.jadeja@johnlewis.co.uk",
        },
        {
          name: "Sophie McDermott",
          jobTitle: "Senior Media Sales & Planning Manager (Computing and Android)",
          category: ", Tech",
          email: "sophie.mcdermott@johnlewis.co.uk",
        },
        {
          name: "Murillo Meireles",
          jobTitle: "Media Sales & Planning Manager",
          category: ", Tech",
          email: "murillo.meireles@johnlewis.co.uk",
        },
        {
          name: "Ryan Warrington",
          jobTitle: "Media Sales & Planning Specialist",
          category: ", Tech",
          email: "ryan.warrington@johnlewis.co.uk",
        },
        {
          name: "Alex Harewood",
          jobTitle: "Media Sales and Planning Manager",
          category: ", Third Party",
          email: "alex.harewood@johnlewis.co.uk",
        },
        {
          name: "Jen Newman",
          jobTitle: "Senior Media Sales and Planning Manager",
          category: ", Third Party",
          email: "jen.newman@johnlewis.co.uk",
        },
        {
          name: "Hari Manivannan",
          jobTitle: "Media Sales & Planning Assistant",
          category: ", Fashion",
          email: "hari.manivannan@johnlewis.co.uk",
        },
        {
          name: "Tanya Kariyawasam",
          jobTitle: "Retail Media Sales & Planning Assistant",
          category: ", Tech",
          email: "tanya.kariyawasam@johnlewis.co.uk",
        },
        {
          name: "Katy Cakebread",
          jobTitle: "Senior Retail Media Sales & Planning Manager",
          category: ", Home",
          email: "katy.cakebread@johnlewis.co.uk",
        },
      ],
    },
    {
      title: "Insights & Media - Waitrose",
      eventKey: "waitrose",
      teamMembers: [
        {
          name: "Laura Wakeling",
          jobTitle: "Retail Media Sales & Planning Lead",
          category: "",
          email: "laura.wakeling@waitrose.co.uk",
        },
        {
          name: "Adam Shinegold",
          jobTitle: "Retail Media Senior Manager",
          category: "Beer, Cider, Soft Drinks, No & Lo and RTD",
          email: "adam.shinegold@waitrose.co.uk ",
        },
        {
          name: "Angela Jones",
          jobTitle: "Retail Media Senior Manager",
          category: "Chilled Meal Solutions",
          email: "angela.jones@waitrose.co.uk",
        },
        {
          name: "Ben Gough",
          jobTitle: "Retail Media Manager",
          category: "Meat, Fish, Poultry, Eggs & Fruit",
          email: "ben.gough@waitrose.co.uk",
        },
        {
          name: "Tash Leyens",
          jobTitle: "Retail Media Senior Manager",
          category: "Third Party",
          email: "natasha.x.leyens@waitrose.co.uk",
        },
        {
          name: "Katie Moore",
          jobTitle: "Retail Media Senior Manager",
          category: "Frozen, Free From & Bakery",
          email: "katie.moore@waitrose.co.uk",
        },
        {
          name: "Katie Kimberley",
          jobTitle: "Retail Media Senior Manager",
          category: "Health & Beauty",
          email: "katie.kimberley@waitrose.co.uk",
        },
        {
          name: "Katy Lawton",
          jobTitle: "Retail Media Senior Manager",
          category: "Grocery Meal Solutions & Core Grocery",
          email: "katy.lawton@waitrose.co.uk",
        },
        {
          name: "Rachel Crowe",
          jobTitle: "Retail Media Senior Manager",
          category: "Spirits & Wine",
          email: "rachel.crowe@waitrose.co.uk",
        },
        {
          name: "Sam Blanch",
          jobTitle: "Retail Media Senior Manager",
          category: "Household & Pet",
          email: "samantha.blanch@waitrose.co.uk",
        },
        {
          name: "Scott King",
          jobTitle: "Retail Media Senior Manager",
          category: "Dairy (inc Juices/Smoothies & Dairy Alts)",
          email: "scott.king@waitrose.co.uk",
        },
        {
          name: "Kirsty Herbert-Evans",
          jobTitle: "Retail Media Senior Manager",
          category: "Grocery Impulse, Confec, Snacks & Biscuits",
          email: "kirsty.herbert.evans@waitrose.co.uk",
        },
        {
          name: "Kirsty Girard",
          jobTitle: "Retail Media Activations Manager",
          category: "",
          email: "kirsty.girard@waitrose.co.uk",
        },
        {
          name: "Beth Knight",
          jobTitle: "Retail Media Activations Specialist",
          category: "",
          email: "bethany.knight@waitrose.co.uk",
        },
        {
          name: "Brooke Bird",
          jobTitle: "Retail Media Activations Specialist",
          category: "",
          email: "brooke.bird@waitrose.co.uk",
        },
        {
          name: "Ellie Spires",
          jobTitle: "Retail Media Activation Specialist",
          category: "",
          email: "ellie.spires@waitrose.co.uk",
        },
        {
          name: "Jordan Drodge",
          jobTitle: "Retail Media Activation Specialist",
          category: "",
          email: "jordan.drodge@waitrose.co.uk",
        },
        {
          name: "Kelsey Timpson",
          jobTitle: "Retail Media Activations Specialist",
          category: "",
          email: "kelsey.timpson@waitrose.co.uk",
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Contact the John Lewis Partnership Insights and Media team
        </title>
        <meta
          name="description"
          content="The John Lewis Partnership Insights and Media team is on hand to help you with any questions. Use the contact form and we'll come back to you."
        />
      </Helmet>
      <div className="team-page">
        <Hero colour={happyOranges.orange} title="Getting results, together" 
          customClass="small-hero"
        />
        <Container className="w-100 main-container">
          <p className="body-l body-text">
            Our dedicated team is on hand to help you with any query you might
            have. Please see below to find out who you should be talking to.
          </p>
          <Tabs fill>
            {tabs.map(({ teamMembers, title, eventKey }) => {
              return (
                <Tab title={title} eventKey={eventKey}>
                  <Row className="team-row">
                    {teamMembers.map(({ name, jobTitle, category, email }) => {
                      return (
                        <Col lg={6} className="mb-4">
                          <p style={{ fontWeight: 700 }} className="body-l">
                            {name}
                          </p>
                          {eventKey === "johnLewis" && (
                            <p className="body-l">
                              {jobTitle}
                              {category}
                            </p>
                          )}
                          {eventKey === "waitrose" && (
                            <>
                              <p className="body-l">{jobTitle}</p>
                              <p className="body-l">{category}</p>
                            </>
                          )}
                          <p className="body-l">{email}</p>
                        </Col>
                      );
                    })}
                  </Row>
                </Tab>
              );
            })}
          </Tabs>
        </Container>
      </div>
    </>
  );
};

export default MeetTheTeamPage;
